import { render, staticRenderFns } from "./r-reward-generator-config-table.vue?vue&type=template&id=abcf027e"
import script from "./r-reward-generator-config-table.vue?vue&type=script&lang=js"
export * from "./r-reward-generator-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abcf027e')) {
      api.createRecord('abcf027e', component.options)
    } else {
      api.reload('abcf027e', component.options)
    }
    module.hot.accept("./r-reward-generator-config-table.vue?vue&type=template&id=abcf027e", function () {
      api.rerender('abcf027e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward-generator/r-reward-generator-config-table.vue"
export default component.exports